<a routerLink="Iscriviti">
<div class="boxr">
  <div class="row" id="rigar">
         Iscriviti
 </div>
</div>
</a>